import { ConverterIF } from '@/components/Input/Converter/ConverterIF'
import '@/util/Extension/StringExtensions'

/**
* 半角数字（整数）のみを許容するinputクラス
* 最大値"max"を指定すると、その範囲チェックも行います。
*/
export default class NumberConverter implements ConverterIF {
    /**
     * @brief	input要素のvalueの値を変換する
     * @param   [in]    target  対象のDOM情報
     * @return	変換後のvalue
     */
    public convertInputValue(target: HTMLInputElement): string {
        if (undefined == target || null == target) {
            return "";
        }

        // 数値でない場合は空文字で取得されるため、空文字で上書きして初期化しておく。
        if ("" === target.value) {
            return "";
        }

        // フォーマットチェック
        let strValue = target.value;

        // 負の値
        // min値が0以上の場合は負の値は許容しないので、チェックも不要
        let bNegative = false;
        const min = parseInt(target.min);
        if (isNaN(min) || min < 0) {
            // 先頭が-のものは負の値
            if (target.value.startsWith("-")) {
                bNegative = true;
                // -だけや-0といった数値として扱えないものは-1として扱う
                if ("-" === target.value || "-0" === target.value) {
                    strValue = "-1";
                }
            }
        }

        // 半角数字以外を取り除く
        strValue = strValue.removeNotHalfNumber();

        // 負の値はremoveNotHalfNumber()で-が除外されるので、ここで付与
        if (bNegative) {
            strValue = "-" + strValue;
        }

        // 最小値・最大値の判定
        if ("" == strValue || null == strValue) {
            // この段階で空白なら一文字目に半角数字が入力されたということ
            return strValue;
        }

        let nValue = parseInt(strValue);

        // 最大値の指定があればチェック
        const max = parseInt(target.max);
        if (false == isNaN(max)) {
            if (max < nValue) {
                nValue = max;
            }
        }

        // 整数に変換する。
        return Math.trunc(nValue).toString();
    }

    /**
     * @brief	TextArea要素のvalueの値を変換する
     * @param   [in]    target  対象のDOM情報
     * @return	変換後のvalue
     */
    public convertTextAreaValue(target: HTMLTextAreaElement): string {
        // TextAreaには非対応のため空文字を返す。
        return "";
    }
}